module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_vm._l((_vm.localValue), function(address, i) {
    return _c('toggle-card', {
      key: 'company-address-' + address.id + '-' + i,
      attrs: {
        "heading": _vm.getHeading(address),
        "visibility": (!address.id || address.id === 'new'),
        "can-delete": true
      },
      on: {
        "delete": function($event) {
          _vm.onDelete(address, i)
        }
      }
    }, [_c('z-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "label": "Тип адреса",
        "name": ('type-' + i),
        "id": ('type-' + i),
        "data-vv-as": " ",
        "data-vv-name": ('type-' + i),
        "error": _vm.errors.first('address-' + i + '.type-' + i),
        "data-vv-scope": ('address-' + i)
      },
      model: {
        value: (address.type_id),
        callback: function($$v) {
          _vm.$set(address, "type_id", $$v)
        },
        expression: "address.type_id"
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "selected": "",
        "value": ""
      }
    }, [_vm._v("Не выбрано")]), _vm._v(" "), _vm._l((_vm.addressTypes), function(type) {
      return _c('option', {
        key: type.id,
        domProps: {
          "value": type.id
        }
      }, [_vm._v(" " + _vm._s(type.name))])
    })], 2), _vm._v(" "), _c('z-input-autocomplete', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          'required': true
        }),
        expression: "{'required': true}"
      }],
      attrs: {
        "label": "Введите точный адрес до номера квартиры/офиса",
        "showOnFocus": true,
        "default": address.address,
        "name": ('address-' + i),
        "id": ('address-' + i),
        "display-property": "unrestricted_value",
        "property": "unrestricted_value",
        "return": "unrestricted_value",
        "data-vv-as": " ",
        "data-vv-name": ('address-' + i),
        "error": _vm.errors.first('address-' + i + '.address-' + i),
        "data-vv-scope": ('address-' + i),
        "required": true,
        "callback": _vm.suggestAddress
      },
      model: {
        value: (address.address),
        callback: function($$v) {
          _vm.$set(address, "address", $$v)
        },
        expression: "address.address"
      }
    }), _vm._v(" "), _c('z-button', {
      staticClass: "md-primary md-dense",
      attrs: {
        "fit-content": "",
        "no-margin": ""
      },
      on: {
        "click": function($event) {
          _vm.saveAddress(address, i, ('address-' + i))
        }
      }
    }, [_vm._v("Сохранить")])], 1)
  }), _vm._v(" "), _c('z-button', {
    attrs: {
      "fit-content": "",
      "no-margin": ""
    },
    on: {
      "click": _vm.addAddress
    }
  }, [_vm._v(" Добавить адрес ")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bc89ffd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/companies/components/CompanyAddress.vue
// module id = 1131
// module chunks = 0